/* eslint-disable no-console */
import { Button, Typography } from '@mui/material';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useStateContext } from '../contexts/ContextProvider';

const CommonCalendar = ({ loading, startDate, handleStartDateChange, endDate, disableFutureDates, handleEndDateChange, bySKU, activePill, vendorList, byVendor }) => {
  const { vendorValue, setVendorValue } = useStateContext();

  const onVendorChange = (selectedOption) => {
    setVendorValue(selectedOption);
  };
  console.log(vendorValue);
  return (
    <div className="container-fluid d-flex justify-content-center align-items-center py-3" id="commondatePicker_id" style={{ marginBottom: '-100px' }}>
      <div className="row justify-content-center align-items-center gx-2" style={{ maxWidth: '750px', padding: '5px', marginTop: '-60px' }} id="datePicker_id2">

        {/* From Label */}
        <div className="col-12 col-md-1 d-flex align-items-center mb-2 mb-md-0">
          <Typography variant="h6">From</Typography>
        </div>

        {/* From DatePicker */}
        <div className={`col-12 ${activePill !== 'home' ? 'col-md-2' : 'col-md-3'} mb-2 mb-md-0`}>
          {loading ? (
            <DatePicker
              disabled
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={startDate}
            />
          ) : (
            <DatePicker
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={startDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="Start date"
              autoComplete="off"
              filterDate={disableFutureDates}
              excludeDates={[new Date()]}
            />
          )}
        </div>

        {/* To Label */}
        <div className="col-12 col-md-0-5 d-flex align-items-center mb-2 mb-md-0">
          <Typography variant="h6">To</Typography>
        </div>

        {/* To DatePicker */}
        <div className={`col-12 ${activePill !== 'home' ? 'col-md-2' : 'col-md-3'} mb-2 mb-md-0`}>
          {loading ? (
            <DatePicker
              disabled
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={endDate}
            />
          ) : (
            <DatePicker
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={endDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="End date"
              autoComplete="off"
              filterDate={disableFutureDates}
              excludeDates={[new Date()]}
            />
          )}
        </div>
        {/* Dropdown */}{
            activePill !== 'home' && (
            <div className="col-12 col-md-5 mb-2 mb-md-0">
              <Select classNamePrefix="Vendor" options={vendorList} onChange={onVendorChange} value={vendorValue || vendorList[0]} placeholder="Select Vendor" />
            </div>
            )
        }
        <div className={`col-12 ${activePill !== 'home' ? 'col-md-1-5' : 'col-md-2'} d-flex align-items-center justify-content-center`}>
          <Button onClick={activePill !== 'home' ? byVendor : bySKU} variant="contained" size="medium">
            Search
          </Button>
        </div>

      </div>
    </div>

  );
};

export default CommonCalendar;
